import styled from '@emotion/styled';
import { rem } from 'polished';
import { themeGet } from 'styled-system';
import { Text, Link } from 'roo-ui/components';

export const DisclaimerItemLogo = styled.img`
  min-width: ${rem('100px')};
  height: ${rem('23px')};
  margin-right: ${themeGet('space.6')};
  margin-top: ${themeGet('space.1')};
  margin-bottom: ${themeGet('space.4')};
`;

export const DisclaimerText = styled(Text)`
  color: ${themeGet('colors.greys.steel')};
  font-size: ${themeGet('fontSizes.xs')};
  margin-bottom: ${themeGet('space.5')};
`;

export const DisclaimerLink = styled(Link)`
  text-decoration: underline;
  color: ${themeGet('colors.greys.steel')};
`;
